module.exports = __webpack_public_path__ + "img/CPS200_R.9f463537.jpg";